import { FunctionComponent } from 'react'
import { LogOut as LogOutIcon } from 'react-feather'
import { MENU_ITEMS, SPACING } from '../constants'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useAuthStore } from '../stores/auth'
import colors from '../colors'
import { Link } from 'react-router-dom'
import useCurrentAppLocation from '../hooks/useCurrentAppLocation'

const Nav: FunctionComponent = () => {
  const user = useAuthStore((state) => state.user)
  const logout = useAuthStore((state) => state.logout)
  const appLocation = useCurrentAppLocation()

  const styles = useStyles()

  const MenuItem = ({ title, Icon, path, id }: { title: string, Icon: any, path: string, id: string }) => {
    const isSelected = appLocation.id === id
    return (
      <Link key={title} to={path}>
        <li
          className={isSelected ? styles.liSelected : styles.li}
        >
          <Icon size={IconSize} className={isSelected ? styles.iconSelected : styles.icon} />
          <span className={styles.menuText}>
            {title}
          </span>
        </li>
      </Link>
    )
  }

  const IconSize = '24'
  const showWalletFeatures = user?.organization?.appleWalletEnabled === true
  const isSuperAdmin = user?.role === 'super_admin'
  const menuItems = [
    MENU_ITEMS.dash,
    MENU_ITEMS.memberships,
    MENU_ITEMS.patrons,
    ...(showWalletFeatures ? [MENU_ITEMS.walletLookup, MENU_ITEMS.notify] : []),
    MENU_ITEMS.announcements,
    MENU_ITEMS.employees,
    MENU_ITEMS.settings,
    ...(isSuperAdmin ? [MENU_ITEMS.stitchDashboard] : []),
    MENU_ITEMS.help
  ]

  const MenuList = () => {
    return (
      <Box className={styles.menuListsContainer}>
        <ul className={styles.list}>
          {menuItems.map(({ ...props }) => (
            <MenuItem key={props.id} {...props} />
          ))}
        </ul>
        <ul className={styles.list}>
          <li className={`${styles.li} ${styles.liNohover}`}>{user && user.email}</li>
          <div onClick={logout} className={styles.logout}>
            <li className={styles.li}>
              <LogOutIcon size={IconSize} className={styles.icon} />
              Log Out
            </li>
          </div>
        </ul>
      </Box>
    )
  }

  const Logo = () => {
    return (
      <img
        src={"/images/bare_logo.png"}
        alt="Stitch Logo"
        width={72}
        height={48}
      />
    )
  }

  return (
    <Box className={styles.container}>
      <Link to="/">
        <Box mb={2} className={styles.logoContainer}>
          <Logo />
        </Box>
      </Link>
      <Box className={styles.menuContainer}>
        <MenuList />
      </Box>
    </Box>
  )
}

const useStyles = makeStyles(() => ({
  container: {
    paddingTop: SPACING * 2,
    display: 'flex',
    flexDirection: 'column',
    background: colors.STITCH_BLUE,
    color: colors.WHITE,
    height: '100vh',
    justifyContent: 'space-between',
    width: 250,
  },
  menuContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  list: {
    listStyleType: 'none',
    paddingInlineStart: 0,
  },
  li: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: SPACING * 2,
    position: 'relative',
    '&:hover': {
      color: colors.LIGHT_BLUE,
    }
  },
  liNohover: {
    '&:hover': {
      color: colors.WHITE,
    }
  },
  liSelected: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: SPACING * 2,
    position: 'relative',
    backgroundColor: colors.STITCH_BLACK,
    fontWeight: 'bold',
    borderLeft: `.25em solid ${colors.YELLOW}`,
    boxSizing: 'border-box',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconSelected: {
    marginRight: SPACING * 1,
    marginLeft: '-.25em',
    strokeWidth: 2,
  },
  icon: {
    marginRight: SPACING * 1,
    strokeWidth: 2,
  },
  menuText: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  menuListsContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  logo: {
    height: 54,
    width: 100
  },
  logout: {
    cursor: 'pointer'
  }
}))

export default Nav
